const { assign, merge } = lodash;

export default function registerHook(settings,name,blocksToModify) {



  if (blocksToModify.includes(name)) {
		var newsettings = {};


		// used this code to get variable from the json file for setting default values.  Need more work and thought on types
		// leaving this option out for now.  The trim was important
		//		(getComputedStyle(document.body,null).getPropertyValue('--wp--custom--zoom').trim() === 'true')},

		newsettings =  assign(newsettings, settings, {
			attributes: merge(settings.attributes, {
				aploeffect: { type: 'string', default: ''},
				aploeffectease: {type: 'string', default: ''},
				aploeffectduration: {type: 'integer',default: ''},
				aploeffectdelay: {type: 'integer',default: ''},
				aplotexture: {type: 'string',default: ''},
            	aploshadow: {type: 'string',default: ''},
				aplomask: {type: 'string',default: ''},
				aplofilters:{ 
					type:Object,
					default:{}
				},
				aplofiltersHover: {
					type:Object,
					default:{}
				},
				aplotransforms:{ 
					type:Object,
					default:{}
				},
				aplotransformsHover: {
					type:Object,
					default:{}
				},
				hasFilters: {type: 'integer', default: 0},
				hasHoverFilters: {type: 'integer', default: 0},
				hasTransforms: {type: 'integer', default: 0},
				hasHoverTransforms: {type: 'integer', default: 0},
				aplohoverduration: {type: 'integer',default:0},
				aplohoverease: {type: 'string',default:''},
				/*aploposition: { type: 'string', default: ''},*/
				aplozindex: {type: 'integer', default:0},
				aplomargintop: {type: 'integer', default:undefined},
				aplomarginbottom: {type: 'integer', default:undefined},
				aplomarginleft: {type: 'integer', default:undefined},
				aplomarginright: {type: 'integer', default:undefined},
			/*	aplopositiontop: {type: 'integer', default:0},
				aplopositionbottom: {type: 'integer', default:0},
				aplopositionleft: {type: 'integer', default:0},
				aplopositionright: {type: 'integer', default:0},*/
				aploclip: {type:'integer',default:0},
				overflowhidden: {type: 'boolean',default:false},
				haspullstyles: {type: 'integer',default:0},
				/*aploanimation: {type:'string', default:''},*/


			}),
		});

		if (name === 'core/cover') {
			newsettings =  assign(newsettings, settings, {
				attributes: merge(settings.attributes, {
					aplocoveroverlay: {type: 'boolean',default: false},
				}),
			});
		}

		if (name === 'core/group' || name==='core/column') {
			newsettings =  assign(newsettings, settings, {
				attributes: merge(settings.attributes, {
					aplopatterngroup: {type: 'string',default: ''},
					backdropFilter: {type:'boolean', default:false},
				}),
			});
		}
		
	/*	if (name === 'core/heading') {
			newsettings =  assign(newsettings, settings, {
				attributes: merge(settings.attributes, {
					aploheadingdecor: {type: 'string',default: ''},
				}),
			});
		}
	*/
		if (name === 'core/gallery') {
			newsettings =  assign(newsettings, settings, {
				attributes: merge(settings.attributes, {
					galleryswitch: {type: 'boolean',default: false},
				/*	aplozoom: {type: 'boolean',default: false},
					aplogrowHover: {type: 'boolean',default: false},*/
				}),
			})
		};
	//	name === 'core/image' ? console.log(settings.attributes) : undefined;
	//	console.log("custom zoom settings:" + getComputedStyle(document.body,null).getPropertyValue('--wp--custom--zoom'));
	//	const valuezoom = getComputedStyle(document.body,null).getPropertyValue('--wp--custom--zoom');
	//	const valuezoombool = (valuezoom.trim() === 'true');
	//	valuezoom.trim() === 'true' ? console.log("custom yes it is true") : console.log("custom no it is false");
	//	console.log(`value custom ${valuezoombool}` );
	//	console.log("type custom " + typeof valuezoom);

		return newsettings;
	}
	return settings;  // just return settings if no blocks are being modified




};